import { Button } from '@tempo-io/sui-button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@tempo-io/sui-dialog';
import { useTranslation } from 'react-i18next';

type DeleteAttachmentDialogProps = {
  attachmentId: number | undefined;
  onClose: () => void;
  onConfirm: (id: number) => void;
};

export const DeleteAttachmentDialog = ({
  attachmentId,
  onClose,
  onConfirm,
}: DeleteAttachmentDialogProps) => {
  const { t } = useTranslation('translation');

  return (
    <Dialog open={attachmentId !== undefined} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t(($) => $.intake.general.deleteAttachment)}</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {t(($) => $.intake.general.areYouSureYouWantToDeleteThisAttachment)}
        </DialogDescription>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            {t(($) => $.common.cancel)}
          </Button>
          <Button
            variant="default"
            data-testid="fim3-confirm-delete-attachment"
            onClick={() => {
              if (attachmentId !== undefined) onConfirm(attachmentId);
            }}
          >
            {t(($) => $.intake.general.delete)}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
